import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';

interface OrionTradingDTO {
  IsTradingAllowed: boolean;
  AllocationsScreenUrl: string | null;
  TradesScreenUrl: string | null;
  ConfirmationsScreenUrl: string | null;
}

export const ORION_TRADING_QUERY_KEY = 'orionTrading';
export const ORION_TRADING_ENDPOINT = '/Consumer/OrionTrading';

const fetchOrionTrading = ({ clientId }): Promise<OrionTradingDTO> =>
  authFetch(`${ORION_TRADING_ENDPOINT}?clientId=${clientId}`);

export const useOrionTradingQuery = ({ clientId }) =>
  useQuery([ORION_TRADING_QUERY_KEY, clientId], () => fetchOrionTrading({ clientId }));
